import React from "react";

function TourneyDetailsSimilarFlightsBadge({
  similarFlights,
  threshold,
  satellites,
}) {
  return (
    <div
      // className={`[clip-path:polygon(0%_0%,100%_0%,90%_100%,100%_100%,0%_100%)] bg-linear-to-b from-warning to-[#CD7F32] absolute text-2xs text-primary font-regular -top-2 px-2 py-0.5 rounded-l-100 left-3`}
      className={` bg-linear-to-b from-warning to-[#CD7F32] absolute text-2xs text-primary font-regular -top-2 px-2 py-0.5 rounded-100 left-3`}
    >
      {!satellites && (
        <div>
          {similarFlights === 1
            ? `${similarFlights} more Flight`
            : `${similarFlights} Similar Flights`}
        </div>
      )}

      {satellites && (
        <div>
          {`${similarFlights} ${satellites ? "Satellite" : "Similar"} Flights`}
        </div>
      )}
    </div>
  );
}

export default TourneyDetailsSimilarFlightsBadge;
